export default __webpack_public_path__ + "static/media/idf.dbe3f7a7.svg";